/**
 * @file WriteoffLotField.tsx
 * @description Поле «Партия» панели списания (phase19.24 этап 1, шаг 1).
 *
 * Вынесено из `WriteoffItemForm`: форма отвечает за строку документа, а
 * правила выбора партии — свой кусок (автовыбор FEFO, срок годности в
 * описании, запрет выбора до фасовки).
 *
 * Партий у фасовки бывает много — выбор поиском (правило A3), нативный список
 * контракт запрещает.
 */

import { Combobox } from "../ui/combobox";
import { WmsFieldLabel } from "./WmsFieldLabel";
import type { LotDto } from "../../lib/api-wms";

interface Props {
  /** Партии выбранной фасовки; пусто — фасовка ещё не выбрана. */
  lots: LotDto[];
  /** Фасовка выбрана: до этого выбирать нечего. */
  hasSku: boolean;
  /** id партии; пусто — автовыбор по сроку годности (FEFO). */
  value: string;
  onChange: (lotId: string) => void;
}

export function WriteoffLotField({ lots, hasSku, value, onChange }: Props) {
  const placeholder = hasSku ? "Автовыбор (FEFO)" : "— сначала выберите фасовку —";
  return (
    <WmsFieldLabel label="Партия">
      <Combobox
        options={[
          { value: "", label: placeholder },
          ...lots.map((lot) => ({
            value: lot.id,
            label: lot.batchNumber,
            description: lot.expiresAt
              ? `до ${new Date(lot.expiresAt).toLocaleDateString("ru-RU")}`
              : "без срока",
          })),
        ]}
        value={value}
        onChange={(next) => onChange(next ?? "")}
        placeholder={placeholder}
        searchPlaceholder="Номер партии"
        emptyText="Партий не нашлось"
        disabled={!hasSku}
        className="min-h-[56px]"
      />
    </WmsFieldLabel>
  );
}
